import { render, staticRenderFns } from "./CreateProject.vue?vue&type=template&id=792a8752&lang=pug"
import script from "./CreateProject.vue?vue&type=script&lang=js"
export * from "./CreateProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('792a8752')) {
      api.createRecord('792a8752', component.options)
    } else {
      api.reload('792a8752', component.options)
    }
    module.hot.accept("./CreateProject.vue?vue&type=template&id=792a8752&lang=pug", function () {
      api.rerender('792a8752', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/chatbots/modules/projects/CreateProject.vue"
export default component.exports